import { Injectable } from '@angular/core';
import { Direction, Directionality } from '@angular/cdk/bidi';

/**
 * Provided as the app's Directionality token (see AppModule) in place of the stock
 * CDK one. The stock Directionality only reads document.documentElement.dir once,
 * the first time anything injects it - whichever Material overlay (dialog, bottom
 * sheet, menu...) happens to be created first locks in that direction for good,
 * even after the user switches language. This one stays live: app.component.ts
 * pushes every language change through `set()`, so overlays opened afterward -
 * and any component subscribed to `change` - pick up the current direction.
 *
 * Extends the CDK class rather than mirroring its shape, so Material components
 * that read newer parts of its API (e.g. mat-form-field's `valueSignal()`) keep working.
 */
@Injectable({ providedIn: 'root' })
export class DirectionService extends Directionality {
  set(direction: Direction): void {
    if (this.value === direction) return;
    this.valueSignal.set(direction);
    this.change.emit(direction);
  }
}
